import {
  Table,
  TableHeader,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
} from "@/components/ui/table";
import { AdditionalPaymentsTableProps } from "./additional-payments-table.types";
import { formatInTimeZone } from "date-fns-tz";
import { formatCurrency } from "@/utils/format/currency";

export const AdditionalPaymentsTable = ({
  data,
  proRataCredits,
  UpdatePayments,
  showTitle,
  showInvoicingCompetency,
}: AdditionalPaymentsTableProps) => {
  const handleUpdatePaymentDate = (
    paymentPosition: number,
    paymentDate: string,
  ) => {
    const updatedPayments = data.map((payment, index) => {
      if (index === paymentPosition) {
        return {
          ...payment,
          paymentDate,
        };
      }

      return payment;
    });

    UpdatePayments && UpdatePayments(updatedPayments);
  };

  const handleUpdateInvoicingCompetencyDate = (
    paymentPosition: number,
    invoicingCompetencyDate: string,
  ) => {
    const updatedPayments = data.map((payment, index) => {
      if (index === paymentPosition) {
        return {
          ...payment,
          invoicingCompetencyDate,
        };
      }

      return payment;
    });

    UpdatePayments && UpdatePayments(updatedPayments);
  };

  if (data.length) {
    return (
      <div className="block w-full bg-white border rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
        <Table>
          {showTitle && (
            <TableHeader className="h-[52px]">
              <TableRow className="hover:bg-white">
                <div className="text-2xl font-semibold font-['Inter'] leading-loose p-4">
                  Pagamentos adicionais
                </div>
              </TableRow>
            </TableHeader>
          )}
          <TableHeader className="h-[52px]">
            <TableRow>
              <TableHead className="px-4 text-zinc-500">ID do Ciclo</TableHead>
              <TableHead className="px-4 text-zinc-500">
                Data de Pagamento
              </TableHead>
              {showInvoicingCompetency && (
                <TableHead className="px-4 text-zinc-500">
                  Competência de faturamento
                </TableHead>
              )}
              <TableHead className="px-4 text-zinc-500">
                Créditos adicionais
              </TableHead>
              <TableHead className="px-4 text-zinc-500">
                Valor adicional
              </TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data?.map((payment, index) => (
              <TableRow className="h-[52px]" key={index}>
                <TableCell className="px-4">{payment.cycleId}</TableCell>
                <TableCell className="px-4">
                  {UpdatePayments ? (
                    <input
                      type="date"
                      defaultValue={formatInTimeZone(
                        payment.paymentDate || new Date().toISOString(),
                        "UTC",
                        "yyyy-MM-dd",
                      )}
                      onBlur={(event) => {
                        handleUpdatePaymentDate(index, event.target.value);
                      }}
                    />
                  ) : (
                    formatInTimeZone(payment.paymentDate, "UTC", "dd/MM/yyyy")
                  )}
                </TableCell>
                {showInvoicingCompetency && (
                  <TableCell className="px-4">
                    {UpdatePayments ? (
                      <input
                        type="date"
                        aria-label="Competência de faturamento"
                        key={`competency-${index}-${payment.invoicingCompetencyDate ?? ""}`}
                        defaultValue={
                          payment.invoicingCompetencyDate
                            ? formatInTimeZone(
                                payment.invoicingCompetencyDate,
                                "UTC",
                                "yyyy-MM-dd",
                              )
                            : ""
                        }
                        onBlur={(event) => {
                          handleUpdateInvoicingCompetencyDate(
                            index,
                            event.target.value,
                          );
                        }}
                      />
                    ) : payment.invoicingCompetencyDate ? (
                      formatInTimeZone(
                        payment.invoicingCompetencyDate,
                        "UTC",
                        "dd/MM/yyyy",
                      )
                    ) : (
                      "—"
                    )}
                  </TableCell>
                )}
                <TableCell className="px-4">
                  {payment.proRata
                    ? `${proRataCredits || payment.capacity} em pró-rata`
                    : payment.capacity}
                </TableCell>
                <TableCell className="px-4">
                  {formatCurrency(payment.amount)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    );
  }
};
